import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from './TitleWithDrag.module.scss';

interface Props {
    title?: React.ReactNode;
    postfix?: React.ReactNode;
    hideDrag?: boolean;
}

export const TitleWithDrag = ({ title, postfix, hideDrag = false }: Props) => {
    return (
        <div className={classes.TitleWithDrag}>
            <span className={`drag-handle ${classes.draghandle} ${hideDrag ? classes.hideDrag : ''}`}>
                <MuiIcon icon={'drag_indicator'} fontSize={'20px'} />
            </span>
            <div className={`${classes.title} ${hideDrag ? classes.hideDrag : ''}`}>
                {title} {postfix && postfix}
            </div>
        </div>
    );
};
